// angular
// 	.module("HeroPRO")
// 	.controller("ProjectDetailsController", projectDetailsController);

import './projectDetails.scss';

/* @ngInject */
export default function projectDetailsController($scope, FRClosingFactory, FRInformationFactory) {
    const vm = this;
    vm.isCollapsed = true;
    vm.approvalAmount = null;

    init();

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.approvalAmount = FRInformationFactory.getAppInfo().ApprovalAmount;
        });

        $scope.$watch(() => FRClosingFactory.getProjectDetailsConfirmed(), (newValue) => {
            vm.isCollapsed = newValue;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/projectDetails/projectdetailsController.js